// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"_29qgu","poweredByImage":"_3X23Z"};